module.exports = __webpack_public_path__ + "img/information.c9582ba2.svg";